import { ref } from "vue";

/**
 * 画面ロジックを扱う composable。
 */
export const useSalesSummarySearchForm = () => {
  //本日日付
  const now = new Date();
  const nowDate =
    now.getFullYear() +
    "-" +
    ("0" + String(Number(now.getMonth()) + 1)).slice(-2) +
    "-" +
    ("0" + now.getDate()).slice(-2);

  const thisMonthFirstDay =
    now.getFullYear() + "-" + ("0" + String(Number(now.getMonth()) + 1)).slice(-2) + "-" + "01";

  // 配達日(From)
  const searchConditionDeliveryDateFrom = ref<string | undefined | null>(thisMonthFirstDay);

  // 配達日(To)
  const searchConditionDeliveryDateTo = ref<string | undefined | null>(nowDate);

  const deliveryDateFromMenuEachDay = ref(false);
  const deliveryDateToMenuEachDay = ref(false);
  const deliveryDateFromMenuEachShop = ref(false);
  const deliveryDateToMenuEachShop = ref(false);

  const formatDateValue = (value: unknown): string | null => {
    if (typeof value === "string") {
      return value;
    }
    if (value instanceof Date) {
      if (Number.isNaN(value.getTime())) {
        return null;
      }
      const year = value.getFullYear();
      const month = String(value.getMonth() + 1).padStart(2, "0");
      const day = String(value.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    if (typeof value === "number") {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return null;
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    return null;
  };

  const onSelectDeliveryDateFrom = (value: unknown): void => {
    searchConditionDeliveryDateFrom.value = formatDateValue(value);
    deliveryDateFromMenuEachDay.value = false;
    deliveryDateFromMenuEachShop.value = false;
  };

  const onSelectDeliveryDateTo = (value: unknown): void => {
    searchConditionDeliveryDateTo.value = formatDateValue(value);
    deliveryDateToMenuEachDay.value = false;
    deliveryDateToMenuEachShop.value = false;
  };

  // 配達ステータス 全て
  const statusSelectedItem = ref<string[]>([]);

  return {
    searchConditionDeliveryDateFrom,
    searchConditionDeliveryDateTo,
    deliveryDateFromMenuEachDay,
    deliveryDateToMenuEachDay,
    deliveryDateFromMenuEachShop,
    deliveryDateToMenuEachShop,
    formatDateValue,
    onSelectDeliveryDateFrom,
    onSelectDeliveryDateTo,
    statusSelectedItem,
  };
};
